
import {BaseDrawer, ICompass, IPoint}  from './BaseDrawer';
import * as PIXI from 'pixi.js-legacy';

/**
 * “田”字形绘制器
 */
export default class RectDrawer extends BaseDrawer { 
    private cellSize = 0; // 单元格大小
    private lineWidth = 2;
    private circleRadius = 0; // 圆形半径
    private gridColor = 0x69A1FF; // 网格颜色
    private quadColor = 0xFFFFFF; // 小四边形颜色
    private sides = 8; // 边数

    constructor(containerRef?: HTMLDivElement,compassPos?: ICompass) {
        super(containerRef,compassPos,false);
        if (containerRef) {
            this.drawTianziShape();
        }
    }

    private calculateCellSize() {
        // 计算2×2网格的单元格大小（取容器最小边的1/2）
        this.cellSize =  this.containerWidth *  (80 / 400);
        this.lineWidth = this.containerWidth * (2 / 400);
        this.circleRadius = this.containerWidth * (16 / 400) * 0.5;
    }

    private drawTianziShape() {
        if (!this.pixiApp) return;
        this.calculateCellSize();
        
        // 计算网格起始位置（居中显示）
        const startX = (this.containerWidth - this.cellSize * 2) / 2;
        const startY = (this.containerHeight - this.cellSize * 2) / 2;

        // 1. 绘制外部网格（2×2）
        this.drawGrid(startX, startY, this.gridColor);

        // 2. 绘制9个小四边形
        this.drawQuads(startX, startY);
    }

    private drawGrid(startX: number, startY: number, color: number) {
        const graphics = new PIXI.Graphics();
        graphics.lineStyle(this.lineWidth, color); // 网格线宽2px

        // 绘制水平线（3条）
        for (let i = 0; i <= 2; i++) {
            const y = startY + i * this.cellSize;
            graphics.moveTo(startX, y);
            graphics.lineTo(startX + 2 * this.cellSize, y);
        }

        // 绘制垂直线（3条）
        for (let i = 0; i <= 2; i++) {
            const x = startX + i * this.cellSize;
            graphics.moveTo(x, startY);
            graphics.lineTo(x, startY + 2 * this.cellSize);
        }

        this.pixiApp?.stage.addChild(graphics);
    }

    private drawQuads(startX: number, startY: number) {
        // 定义9个原形的位置（2×2网格中的9个关键点）
        const positions = [
            { x: startX, y: startY },                     // 左上角
            { x: startX + this.cellSize, y: startY },      // 上边中点
            { x: startX + 2 * this.cellSize, y: startY },  // 右上角
            { x: startX, y: startY + this.cellSize },      // 左边中点
            { x: startX + this.cellSize, y: startY + this.cellSize }, // 中心
            { x: startX + 2 * this.cellSize, y: startY + this.cellSize }, // 右边中点
            { x: startX, y: startY + 2 * this.cellSize },  // 左下角
            { x: startX + this.cellSize, y: startY + 2 * this.cellSize }, // 下边中点
            { x: startX + 2 * this.cellSize, y: startY + 2 * this.cellSize } // 右下角
        ];

        //绘制八边形
        positions.forEach(pos => {
            const graphics = new PIXI.Graphics();
            
            const points = []
            for(let i = 0; i < this.sides; i++){
                const angle = (i / this.sides) * Math.PI * 2;
                points.push(pos.x + Math.cos(angle) * this.circleRadius, pos.y + Math.sin(angle) * this.circleRadius);
            }
            graphics.beginFill(this.quadColor,1); //填充颜色
            graphics.drawPolygon(points); // 绘制多边形
            graphics.endFill();
            this.pixiApp?.stage.addChild(graphics);
        });
    }


    public resizeHandler(isFlytoPage?: boolean): void {
        if(!this.containerRef || !this.pixiApp) return
        this.initContainer();
        this.renderResize();
        this.drawTianziShape();
        this.drawCompass();
    }
}
